var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-text-field',_vm._b({ref:"input",attrs:{"clearable":!_vm.$attrs.readonly,"value":_vm.model.value,"inputmode":"numeric"},on:{"input":_vm.onInput,"autoNumeric:formatted":() => {
      this.changedByInput = false; // Remove the flag when autonumeric finish formatting
    }},scopedSlots:_vm._u([_vm._l((_vm.$slots),function(index,name){return {key:name,fn:function(){return [_vm._t(name)]},proxy:true}})],null,true)},'v-text-field',{ ..._vm.$attrs },false))
}
var staticRenderFns = []

export { render, staticRenderFns }